import { Button } from "@do/ui/components/button";
import { cn } from "@do/ui/lib/utils";
import { useTranslations } from "next-intl";
import { useCallback } from "react";
import { stripEmojisFromString } from "../../../../lib/strip-emojis-from-string";
import { useChat } from "../../../../providers/chat-provider";
import { PlayStoreIcon } from "../../../icons/play-store";
import { type MessageButtonProps } from "./button";
import { ButtonIcon } from "./button-icon";

export const MessagePlayStoreButton = ({
  button,
  buttonType: _,
  className,
  isBackButton: _isBackButton,
  template,
  id,
  ...props
}: MessageButtonProps) => {
  const { onFastAction } = useChat();
  const t = useTranslations("do-chat-v2");

  const handleClick = useCallback(() => {
    onFastAction({
      id,
      metadata: button.metadata,
      title: button.title,
      url: `https://play.google.com/store/apps/details?id=${button.packageName}`,
    });
  }, [onFastAction, id, button]);

  return (
    <Button
      id={`message-${button.id}-play-store-button`}
      onClick={handleClick}
      className={cn(
        "chat-message-button-play-store",
        "bg-(--message-store-buttons-background)/(--message-store-buttons-background-opacity)",
        "hover:bg-(--message-store-buttons-hover-background)/(--message-store-buttons-hover-background-opacity)",
        "text-(--message-store-buttons-foreground)/(--message-store-buttons-foreground-opacity)",
        "hover:text-(--message-store-buttons-hover-foreground)/(--message-store-buttons-hover-foreground-opacity)",
        "border-(length:--message-store-buttons-border-width)",
        "border-(--message-store-buttons-border-color)/(--message-store-buttons-border-opacity)",
        "hover:border-(--message-store-buttons-hover-border-color)/(--message-store-buttons-hover-border-opacity)",
        "rounded-(--message-store-buttons-border-radius)",
        "min-h-(--message-store-buttons-height)",
        "gap-(--message-store-buttons-gap)",
        "font-(--message-store-buttons-font-weight)! font-(family-name:--message-store-buttons-font-family)",
        "text-(length:--message-store-buttons-font-size)",
        "[box-shadow:var(--message-store-buttons-box-shadow)]",
        className
      )}
      aria-label={
        button.appName
          ? t("chat.messages.accessibility.message-play-store-aria-label", {
              appName: button.appName,
            })
          : t("chat.messages.accessibility.message-play-store-default-aria-label")
      }
      title={button.title && stripEmojisFromString(button.title)}
      {...props}
    >
      <ButtonIcon
        buttonType="store"
        template={template}
        buttonId={button.id}
        storeIcon={PlayStoreIcon}
      />
      Google Play
    </Button>
  );
};
